var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageIcon = function SvgMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3 18h1.8M21 18h-1.8M4.8 18v-7.8A7.2 7.2 0 0 1 12 3v0a7.2 7.2 0 0 1 7.2 7.2V18M4.8 18h4.5m9.9 0h-4.5m-5.4 0v.3A2.7 2.7 0 0 0 12 21v0a2.7 2.7 0 0 0 2.7-2.7V18m-5.4 0h5.4"
  })));
};
export default SvgMessageIcon;